import { ImageSection } from "@domain/lms/article/article";
import { SectionController } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionController";
export class ImageSectionController extends SectionController<ImageSection> {}
